import { useState } from "react";

const SNOOZE_OPTIONS: { label: string; days?: number }[] = [
  { label: "7 days", days: 7 },
  { label: "14 days", days: 14 },
  { label: "30 days", days: 30 },
  { label: "Until I unsnooze", days: undefined },
];

// A small "Snooze ▾" dropdown shared by the operational alerts panel and the
// "Flocks to act on" card. allowIndefinite hides the "Until I unsnooze" option —
// operational (category-wide) alerts must stay time-bounded (backend enforces it),
// flock alerts may be muted indefinitely.
export default function SnoozeMenu({
  allowIndefinite,
  onPick,
  ariaLabel = "Snooze this alert",
}: {
  allowIndefinite: boolean;
  onPick: (days?: number) => void;
  ariaLabel?: string;
}) {
  const [open, setOpen] = useState(false);
  const options = allowIndefinite ? SNOOZE_OPTIONS : SNOOZE_OPTIONS.filter((o) => o.days !== undefined);
  return (
    <div className="relative shrink-0">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label={ariaLabel}
        className="mt-1 rounded-md px-2 py-1 text-xs font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-white/[0.06] dark:hover:text-gray-200"
      >
        Snooze
      </button>
      {open && (
        <>
          {/* Backdrop closes the menu on an outside click. */}
          <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} aria-hidden />
          <div className="absolute right-0 z-20 mt-1 w-44 rounded-lg border border-gray-200 bg-white py-1 shadow-lg dark:border-gray-700 dark:bg-gray-900">
            {options.map((opt) => (
              <button
                key={opt.label}
                type="button"
                onClick={() => {
                  setOpen(false);
                  onPick(opt.days);
                }}
                className="block w-full px-3 py-1.5 text-left text-xs text-gray-700 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-white/[0.06]"
              >
                {opt.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
